// Small brand marks shown next to tools, AI models and websites named in Vikasifications articles.
// Each file in public/logos/ is the brand's own site icon, saved locally so a page makes no outside
// requests. A brand is found by the link's domain, or by its exact name in a bold phrase or a numbered heading.
// Adding one: save public/logos/<slug>.png (64px) and add a line here.
const BRANDS = [
  ['claude', 'Claude', ['claude.com', 'claude.ai', 'anthropic.com'], ['Claude Code']],
  ['chatgpt', 'ChatGPT', ['chatgpt.com', 'chat.openai.com', 'openai.com'], ['OpenAI']],
  ['gemini', 'Gemini', ['gemini.google.com', 'ai.google.dev'], []],
  ['cursor', 'Cursor', ['cursor.com', 'cursor.sh'], []],
  ['perplexity', 'Perplexity', ['perplexity.ai'], []],
  ['deepseek', 'DeepSeek', ['deepseek.com'], []],
  ['granola', 'Granola', ['granola.ai'], []],
  ['fathom', 'Fathom', ['fathom.video'], []],
  ['gamma', 'Gamma', ['gamma.app'], []],
  ['canva', 'Canva', ['canva.com'], []],
  ['descript', 'Descript', ['descript.com'], []],
  ['zapier', 'Zapier', ['zapier.com'], []],
  ['make', 'Make', ['make.com'], []],
  ['mercury', 'Mercury', ['mercury.com'], []],
  ['ramp', 'Ramp', ['ramp.com'], []],
  ['quickbooks', 'QuickBooks', ['quickbooks.intuit.com'], []],
  ['stripe', 'Stripe', ['stripe.com'], []],
  ['attio', 'Attio', ['attio.com'], []],
  ['hubspot', 'HubSpot', ['hubspot.com'], []],
  ['pipedrive', 'Pipedrive', ['pipedrive.com'], []],
  ['folk', 'Folk', ['folk.app'], []],
  ['streak', 'Streak', ['streak.com'], []],
  ['salesforce', 'Salesforce', ['salesforce.com'], []],
  ['notion', 'Notion', ['notion.so', 'notion.com'], []],
  ['figma', 'Figma', ['figma.com'], []],
  ['mongodb', 'MongoDB', ['mongodb.com'], []],
  ['render', 'Render', ['render.com'], []],
  ['vercel', 'Vercel', ['vercel.com'], []],
  ['bitbucket', 'Bitbucket', ['bitbucket.org'], []],
  ['github', 'GitHub', ['github.com'], []],
  ['fastapi', 'FastAPI', ['fastapi.tiangolo.com'], []],
  ['react', 'React', ['react.dev', 'reactjs.org'], []],
  ['cloudflare', 'Cloudflare', ['cloudflare.com'], ['Cloudflare R2']],
  ['pexels', 'Pexels', ['pexels.com'], []],
  ['unsplash', 'Unsplash', ['unsplash.com'], []],
  ['resend', 'Resend', ['resend.com'], []],
  ['emergent', 'Emergent', ['emergent.sh'], []],
  ['pandascore', 'PandaScore', ['pandascore.co'], []],
  ['googlenews', 'Google News', ['news.google.com'], []],
  ['riyadbank', 'Riyad Bank', ['riyadbank.com'], []],
  ['shorooq', 'Shorooq', ['shorooq.com'], []],
  ['e27', 'e27', ['e27.co'], []],
  ['financemiddleeast', 'Finance Middle East', ['financemiddleeast.com'], []],
  ['amazon', 'Amazon', ['amazon.in', 'amazon.com'], []],
  ['klook', 'Klook', ['klook.com'], []],
];

const byDomain = {};
BRANDS.forEach(([slug, , domains]) => {
  domains.forEach((d) => { byDomain[d] = slug; });
});

// 'https://docs.claude.com/x' -> 'claude'; subdomains fall back to the parent domain.
export function logoForHref(href) {
  const m = /^https?:\/\/([^/?#]+)/i.exec(href || '');
  if (!m) return null;
  let host = m[1].toLowerCase().replace(/^www\./, '');
  while (host.includes('.')) {
    if (byDomain[host]) return byDomain[host];
    host = host.slice(host.indexOf('.') + 1);
  }
  return null;
}

// Exact, case-sensitive name: '**HubSpot**' matches, '**make**' does not.
const exact = {};
BRANDS.forEach(([slug, name, , aliases]) => [name, ...aliases].forEach((n) => { exact[n] = slug; }));
export function logoForName(text) {
  return exact[String(text || '').trim()] || null;
}

// Numbered tool headings such as '3. Cursor' or '1. Claude and 2. ChatGPT'. Only a name straight after
// the number counts, and case must match, so an ordinary heading like 'Make it pay' never gets a logo.
const NAMES = Object.keys(exact).sort((a, b) => b.length - a.length);
const ESC = (n) => n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
export const NUMBERED_NAME = new RegExp(`(\\d+\\.\\s+)(${NAMES.map(ESC).join('|')})\\b`, 'g');

export function BrandLogo({ slug, className = '' }) {
  if (!slug) return null;
  return (
    <img
      src={`/logos/${slug}.png`}
      alt=""
      aria-hidden="true"
      width="16"
      height="16"
      className={`inline-block w-[1em] h-[1em] rounded-[3px] align-[-0.125em] me-[0.3em] ${className}`}
    />
  );
}
